export default function LandingPage({ operationalStates }) {
  if (Object.keys(operationalStates).length === 0) {
    return (
      <div className='landing-page-info'>
        <h2 className='info'>Waiting for states list...</h2>
      </div>
    );
  }

  return (
    <div className='landing-page-info'>
      <div className='info'>
        <h2>Welcome to the Floodcast Dashboard.</h2>
        <br></br>
        <h3>
          Note: coastal states are not currently shown due to a change in the source data provider for tide height forecasts.
        </h3>
        <br></br>
        This dashboard displays forecasted water surface elevations at
        transportation assets, by converting stream flow forecasts into water
        surface elevations via hydraulic models. It uses&nbsp;
        <a
          href='https://water.weather.gov/ahps/'
          target='_blank'
          rel='noreferrer'
        >
          AHPS
        </a>
        &nbsp;color-coding for a visual cue of flood threat levels.
        <br></br>
        <br></br>
        <b>
          <i>
            To get started, select a state from the dropdown in the top left.
          </i>
        </b>
        <br></br>
        <br></br>
        <br></br>
        This is an experimental product developed for a research project for
        the&nbsp;
        <a
          href='https://www.nationalacademies.org/'
          target='_blank'
          rel='noreferrer'
        >
          National Academies of Sciences, Engineering, and Medicine
        </a>
        &nbsp;and the&nbsp;
        <a
          href='https://www.trb.org/NCHRP/NCHRP.aspx'
          target='_blank'
          rel='noreferrer'
        >
          National Cooperative Highway Research Program (NCHRP)
        </a>
        .<br></br>
        <br></br>
        For more information on the project history, visit&nbsp;
        <a
          href='http://floodcast.info/wordpress/'
          target='_blank'
          rel='noreferrer'
        >
          floodcast.info
        </a>
        .
      </div>
    </div>
  );
}
